import Header from "../Header/Header";
import Home from "../../pages/Home";
import Reason from "../reason/Reason";
import Footers from "../../Footer/Footer";

export default function sets() {
    return (
        <div>
            <Header />
            <Home />
            <Reason />
            <Footers />
        </div>

    )
}